import React from "react";
import Card from "@/component/card";

const createAhorroLabel = (cardData) => {
  const res = cardData;
  const { originalPrice, monthlyPayment } = cardData;
  const r2rPrice = cardData["Price-2"]?.amount;
  if (r2rPrice && originalPrice && monthlyPayment) {
    const ahorro =
      parseFloat(monthlyPayment) * parseFloat(r2rPrice) -
      parseFloat(originalPrice) +
      1;
    if (ahorro < -10) {
      res["Label-2"] = {
        label: `${ahorro}€ vs. libre`,
        theme: "discount",
        inversed: false,
        notBorderRadius: true
      };
    }
  }
  return res;
};

const DevicesOffers = ({ cardData, taggingInfo }) => {
  const labelAhorro = createAhorroLabel(cardData);
  return (
    <>
      <div className="featured-dispo-card">
        <Card
          taggingInfo={taggingInfo}
          {...{ ...cardData, ...labelAhorro }}
          imageClassName="aspect-ratio-4-5"
        ></Card>
      </div>

      <style jsx>
        {`
          .featured-dispo-card {
            height: 100%;

            :global(.card-column) {
              // min-width: 272px;
              min-height: 200px;
              width: 11.9rem;
            }

            :global(.card) {
              padding: 1.5rem;
            }

            :global(.card-container) {
              gap: 0.7rem;
              align-items: flex-start;
              flex-flow: column nowrap;
              flex: 1;

              :global(.card-container--image) {
                max-width: 8.25rem;
              }

              :global(.card-content--price) {
                line-height: 1.25rem;

                :global(.price) {
                  display: inline-block;
                  margin-right: 0.2rem;
                }

                :global(.price--pre-price) {
                  display: block;
                }
              }

              :global(.card-header) {
                min-height: 2.5rem;

                :global(.card-header--title) {
                  display: -webkit-box;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                }
              }

              :global(.card-container--info) {
                gap: 0.7rem;
                flex: 1;
              }
            }
          }

          @media screen and (min-width: 768px) {
            .featured-dispo-card {
              :global(.card-column) {
                height: 100%;
                width: inherit;

                :global(.card-header--title) {
                  line-height: 1.5rem;
                }
              }

              :global(.card-container) {
                flex-flow: row nowrap;
                align-items: center;
                flex: inherit;

                :global(.card-container--image) {
                  max-width: unset;
                }

                :global(.card-header) {
                  min-height: inherit;

                  :global(.text) {
                    line-height: 1.5rem;
                  }
                }
              }
            }
          }

          @media screen and (min-width: 1280px) {
            .featured-dispo-card {
              :global(.card-column) {
                min-width: 0;
                height: 100%;
              }

              :global(.card) {
                :global(.offer-progress) {
                  display: block;

                  :global(.offer--text) {
                    display: flex;
                    justify-content: space-between;
                  }
                }
              }

              :global(.card-container) {
                :global(.card-container--label) {
                  display: block;
                  width: 100%;
                }

                :global(.card-content--price) {
                  :global(.price--pre-price) {
                  }
                }

                :global(.card-header) {
                  :global(.text) {
                    line-height: 1.5rem;
                  }
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default DevicesOffers;
